<prt-template [isDemo]="isDemo" [today]="today" [plan]="currentCase">
	<div class="row">
		<div class="col-4">
			<div class="wrapper-print-tab">
				<h4>{{ labels().DRAWER_COMPONENT_TITLE_CORRECTION }}</h4>
			</div>

			<prt-apex-table />
			@if (hasAP) { <prt-lld-table /> }
			@if (isMNSA) { <prt-mnsa-table /> }
			@if (plate) { <prt-rec-clinic-measures /> }

		</div>
		<div class="col-8">
			<div class="wrapper-print-tab">
				<h4>{{ labels().PRINT_XRAY_IMAGE_TITLE }}</h4>
			</div>
			<div class="wrapper-canvas">
				<img [src]="canvasSrc" alt="xray imgs" width="850" height="750" />
			</div>
		</div>
	</div>
</prt-template>